import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_NurseAx = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_NurseAx' className='file-pdf-document'>
            <div className='file-template'>




                <h4 >
                    <center>
                        Advance Therapeutic Concepts<br />
                        2795 Main Street West, Suite 20-B, Snellville, GA 30078<br />
                        Telephone: 678-344-7836 Fax: 678-892-8575</center>
                </h4>
                <h2 >
                    <center>
                        Nursing Assessment</center>
                </h2>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of PCP:</span>
                            <input type="text" id="txtNameOfPCP" name="txtNameOfPCP" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'><strong>Release of information signed for PCP: </strong></span>
                            <input type="radio" id="rbInformationSigned_Yes" name="rbInformationSigned" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbInformationSigned_No" name="rbInformationSigned" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbInformationSigned_NA" name="rbInformationSigned" className='add-only' value="N/A" /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Temp:</span>
                            <input type="text" id="txtTemp" name="txtTemp" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pulse:</span>
                            <input type="text" id="txtPulse" name="txtPulse" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Resp:</span>
                            <input type="text" id="txtResp" name="txtResp" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>B/P:</span>
                            <input type="text" id="txtBP" name="txtBP" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ht: </span>
                            <input type="text" id="txtHt" name="txtHt" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Wgt: </span>
                            <input type="text" id="txtWgt" name="txtWgt" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Medical History: (including surgery)</span>
                    <input type="checkbox" id="cbMedicalHistory" name="cbMedicalHistory" className='add-only' value="No significant problems" /> No significant problems
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>When did you last see a physician or other health provider? </span>
                    <textarea id="txtPhysicianHealthProvider" name="txtPhysicianHealthProvider" className='add-only'></textarea>
                </p>


                <h4>Immunizations:</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current:</span>
                            <input type="radio" id="rbCurrent_Yes" name="rbCurrent" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCurrent_No" name="rbCurrents" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Lab Tests:</span>
                            <input type="radio" id="rbLabTests_Yes" name="rbLabTests" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLabTests_No" name="rbLabTests" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Present Condition:</span>
                            <input type="radio" id="rbPresentCondition_Noknown" name="rbPresentCondition" className='add-only' value="No known problems" /> No known problems &nbsp;
                            <input type="radio" id="rbPresentCondition_Yes" name="rbPresentCondition" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtImmunizations" name="txtImmunizations" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Family History:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamilyHistory_1" name="cbFamilyHistory_1" className='add-only' value="Obesity" /> Obesity
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamilyHistory_2" name="cbFamilyHistory_2" className='add-only' value="Diabete" /> Diabete
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamilyHistory_3" name="cbFamilyHistory_3" className='add-only' value="Dyslipidemia" /> Dyslipidemia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamilyHistory_4" name="cbFamilyHistory_4" className='add-only' value="Hypertension" /> Hypertension
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamilyHistory_5" name="cbFamilyHistory_5" className='add-only' value="Cardiovascular Disease" /> Cardiovascular Disease
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbFamilyHistory_other" name="cbFamilyHistory_other" className='add-only' value="other" /> other
                            <input type="text" id="txtFamilyHistory_other" name="txtFamilyHistory_other" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medications Allergies </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbAllergies_1" name="rbAllergies_1" className='add-only' value="No known" /> No known &nbsp;
                            <input type="radio" id="rbAllergies_2" name="rbAllergies_2" className='add-only' value="List & Describe" /> List & Describe
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Pharmacy Used:</span>
                            <input type="text" id="txtPharmacyUsed" name="txtPharmacyUsed" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>AIMS:</span>
                            <input type="text" id="txtAims" name="txtAims" className='add-only' />
                            If &#62; 0, complete AIMS Attachment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-170'><span className='eleHeader'>Current Medications</span></td>
                        <td className='w-140'><span className='eleHeader'>Dose</span></td>
                        <td className='w-140'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-150'><span className='eleHeader'>Last Dose </span></td>
                        <td className='w-150'><span className='eleHeader'>Ordered by </span></td>
                    </tr>
                    <tr>
                        <td className='w-170'>
                            <input type="text" id="txtCurrentMedications_1" name="txtCurrentMedications_1" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtLastDose_1" name="txtLastDose_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtOrderedBy_1" name="txtOrderedBy_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-170'>
                            <input type="text" id="txtCurrentMedications_2" name="txtCurrentMedications_2" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtLastDose_2" name="txtLastDose_2" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtOrderedBy_2" name="txtOrderedBy_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-170'>
                            <input type="text" id="txtCurrentMedications_3" name="txtCurrentMedications_3" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtDose_3" name="txtDose_3" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtLastDose_3" name="txtLastDose_3" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtOrderedBy_3" name="txtOrderedBy_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-170'>
                            <input type="text" id="txtCurrentMedications_4" name="txtCurrentMedications_4" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtDose_4" name="txtDose_4" className='add-only' /></td>
                        <td className='w-140'>
                            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtLastDose_4" name="txtLastDose_4" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="text" id="txtOrderedBy_4" name="txtOrderedBy_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the consumer taking any herbal, OTC, or vitamin supplements?</span>
                            <input type="radio" id="rbVitaminSupplements_Yes" name="rbVitaminSupplements" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbVitaminSupplements_No" name="rbVitaminSupplements" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <h3>SUICIDE RISK ASSESSMENT:</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current Potential of Injury to Self:</span>

                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbCurrentPotential_None" name="rbCurrentPotential" className='add-only' value="None" /> None
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbCurrentPotential_Suicide" name="rbCurrentPotential" className='add-only' value="Suicide" /> Suicide
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbCurrentPotential_SelfMutilation" name="rbCurrentPotential" className='add-only' value="Self-Mutilation" /> Self-Mutilation
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Current Plan Available Means and Intent:</span>
                    <textarea id="txtIntent" name="txtIntent" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any history of Suicidal Ideation or Attempt:</span>
                    <input type="radio" id="rbSuicidalIdeation_None" name="rbSuicidalIdeation" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbSuicidalIdeation_Yes" name="rbSuicidalIdeation" className='add-only' value="Yes" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe: </span>
                    <textarea id="txtSuicidalIdeation_Describe" name="txtSuicidalIdeation_Describe" className='add-only'></textarea>
                </p>
                <h3>AGGRESSION/HOMICIDE RISK ASSESSMENT: </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current Homicidal Ideation Plan: </span>
                    <input type="radio" id="rbCurrentHomicidal_None" name="rbCurrentHomicidal" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbCurrentHomicidal_Yes" name="rbCurrentHomicidal" className='add-only' value="Yes" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe: </span>
                    <textarea id="txtCurrentHomicidal_Describe" name="txtCurrentHomicidal_Describe" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type="checkbox" id="cbDutyToWarn" name="cbDutyToWarn" className='add-only' value="Duty to Warn if applicable" /> <strong>Duty to Warn, if applicable</strong>
                    <textarea id="txtDutyToWarn" name="txtDutyToWarn" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legal Issues/Jail:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbLegalIssues_None" name="rbLegalIssues" className='add-only' value="None" /> None
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbLegalIssues_Current" name="rbLegalIssues" className='add-only' value="Current" /> Current
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbLegalIssues_Past" name="rbLegalIssues" className='add-only' value="Past" /> Past
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any current or past problems (include dates): </span>
                    <textarea id="txtPastProblems" name="txtPastProblems" className='add-only'></textarea>
                </p>
                <h3>PRESENTATION: </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Chief Compliant (consumer's words): </span>
                    <textarea id="txtChiefCompliant" name="txtChiefCompliant" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Present Illness:</span>
                    <textarea id="txtPresentIllness" name="txtPresentIllness" className='add-only'></textarea>
                </p>
                <h3>PSYCHIATRIC/ADDICTIVE DISEASE HOSPITALIZATION: </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Hospitalization: </span>
                    <input type="radio" id="rbHospitalization_None" name="rbHospitalization" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbHospitalization_Yes" name="rbHospitalization" className='add-only' value="Yes" /> Yes(Hospital/Rehab)
                </p>
                <p className='w-750'>
                    <textarea id="txtHospitalization" name="txtHospitalization" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recent Hospitalization/Rehab: </span>
                    <input type="radio" id="rbRecentHospitalization_None" name="rbRecentHospitalization" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbRecentHospitalization_Yes" name="rbRecentHospitalization" className='add-only' value="Yes" /> Yes
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last admission: </span>
                            <input id="txtDateOfLastAdmission" name="txtDateOfLastAdmission" className='add-only' type='date' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Location:</span>
                            <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Outpatient Treatment/Medication Clinic:</span>
                    <input type="radio" id="rbOutpatientTreatment_None" name="rbOutpatientTreatment" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbOutpatientTreatment_Yes" name="rbOutpatientTreatment" className='add-only' value="Yes" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe</span>
                    <textarea id="txtOutpatientTreatment_Describe" name="txtOutpatientTreatment_Describe" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History of Mental Illness, Suicide, Addictive Disease and or Treatment:</span>
                    <input type="radio" id="rbAddictiveDisease_None" name="rbAddictiveDisease" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbAddictiveDisease_Yes" name="rbAddictiveDisease" className='add-only' value="Yes" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe</span>
                    <textarea id="txtAddictiveDisease_Describe" name="txtAddictiveDisease_Describe" className='add-only'></textarea>
                </p>

                <h3>SLEEP/REST: </h3>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_1" name="cbSleepRest_1" className='add-only' value="No problem" />No problem </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_2" name="cbSleepRest_2" className='add-only' value="More than usual" />More than usual </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_3" name="cbSleepRest_3" className='add-only' value="Awakening early" />Awakening early </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_4" name="cbSleepRest_4" className='add-only' value="Staying asleep" />Staying asleep </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_5" name="cbSleepRest_5" className='add-only' value="Disturbed" />Disturbed </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_6" name="cbSleepRest_6" className='add-only' value="Naps" />Naps</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_7" name="cbSleepRest_7" className='add-only' value="Less than usual" />Less than usual </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_8" name="cbSleepRest_8" className='add-only' value="Night sweats" />Night sweats </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSleepRest_9" name="cbSleepRest_9" className='add-only' value="Falling sleep" />Falling sleep </td>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSleepRest_10" name="cbSleepRest_10" className='add-only' value="Nightmares" />Nightmares-(this was left off) </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSleepRest_11" name="cbSleepRest_11" className='add-only' value="Average Hours/Night" />Average Hours/Night:
                            <input type="text" id="txtAverageHoursNight" name="txtAverageHoursNight" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>NEUROLOGICAL:</h3>
                <span className='eleHeader'>Pupils:</span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbPupils_Equal" name="rbPupils" className='add-only' value="Equal" /> Equal</td>
                        <td className='w-250'>
                            <input type="radio" id="rbPupils_Unequal" name="rbPupils" className='add-only' value="Unequal" /> Unequal</td>
                        <td className='w-250'>
                            <input type="radio" id="rbPupils_Dilated" name="rbPupils" className='add-only' value="Dilated" /> Dilated</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id="txtPupils_Explain" name="txtPupils_Explain" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Vision:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbVision_1" name="rbVision" className='add-only' value="No difficulty reported" /> No difficulty reported
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbVision_2" name="rbVision" className='add-only' value="Glasses/Contacts" /> Glasses/Contacts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbVision_Other" name="rbVision" className='add-only' value="Other" /> Other:
                            <textarea id="txtVision_Other" name="txtVision_Other" className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hearing:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbHearing_1" name="rbHearing" className='add-only' value="No difficulty reported" /> No difficulty reported
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbHearing_2" name="rbHearing" className='add-only' value="Aids" /> Aids
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="radio" id="cbHearing_Other" name="rbHearing" className='add-only' value="Other" /> Other:
                    <textarea id="txtHearing_Other" name="txtHearing_Other" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbSpeech_1" name="rbSpeech" className='add-only' value="No difficulty reported" /> No difficulty reported
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbSpeech_2" name="rbSpeech" className='add-only' value="Aphasia" /> Aphasia
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="radio" id="rbSpeech_Other" name="rbSpeech" className='add-only' value="Other" /> Other:
                    <textarea id="txtSpeech_other" name="txtSpeech_other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Seizures:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbSeizures_None" name="rbSeizures" className='add-only' value="None" /> None &nbsp;
                            <input type="radio" id="rbSeizures_Yes" name="rbSeizures" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtSeizures_Describe" name="txtSeizures_Describe" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Headaches:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbHeadaches_No" name="rbHeadaches" className='add-only' value="No" />  No &nbsp;
                            <input type="radio" id="rbHeadaches_Yes" name="rbHeadaches" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtHeadaches_Describe" name="txtHeadaches_Describe" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Paralysis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbParalysis_None" name="rbParalysis" className='add-only' value="None" /> None &nbsp;
                            <input type="radio" id="rbParalysis_Yes" name="rbParalysis" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtParalysis_Describe" name="txtParalysis_Describe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Numbness:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbNumbness_None" name="rbNumbness" className='add-only' value="None" />  None &nbsp;
                            <input type="radio" id="rbNumbness_Yes" name="rbNumbness" className='add-only' value="Yes" />  Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtNumbness_Describe" name="txtNumbness_Describe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Dizziness:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbDizziness_None" name="rbDizziness" className='add-only' value="None" /> None &nbsp;
                            <input type="radio" id="rbDizziness_Yes" name="rbDizziness" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtDizziness_Describe" name="txtDizziness_Describe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbOther_None" name="rbOther" className='add-only' value="None" /> None &nbsp;
                            <input type="radio" id="rbOther_Yes" name="rbOther" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtOther_Describe" name="txtOther_Describe" className='add-only'></textarea>
                </p>
                <h3>GASTROINTESTINAL:</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Teeth:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTeeth_1" name="cbTeeth_1" className='add-only' value="No problem" />No problem </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTeeth_2" name="cbTeeth_2" className='add-only' value="Pain" />Pain </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTeeth_3" name="cbTeeth_3" className='add-only' value="Braces" />Braces</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTeeth_4" name="cbTeeth_4" className='add-only' value="Caries" />Caries</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTeeth_5" name="cbTeeth_5" className='add-only' value="Edentulous" />Edentulous</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eating Problems:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEatingProblems_1" name="cbEatingProblems_1" className='add-only' value="None" />None</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEatingProblems_2" name="cbEatingProblems_2" className='add-only' value="Swallowing" />Swallowing </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEatingProblems_3" name="cbEatingProblems_3" className='add-only' value="Choking" />Choking</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEatingProblems_4" name="cbEatingProblems_4" className='add-only' value="Chewing" />Chewing</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEatingProblems_5" name="cbEatingProblems_5" className='add-only' value="Tasting" />Tasting</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Elimination Process:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_1" name="cbEliminationProcess_1" className='add-only' value="No problem" />No problem </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_2" name="cbEliminationProcess_2" className='add-only' value="Constipation" />Constipation </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_3" name="cbEliminationProcess_3" className='add-only' value="Blood in stool" />Blood in stool</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_4" name="cbEliminationProcess_4" className='add-only' value="Laxative" />Laxative</td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_5" name="cbEliminationProcess_5" className='add-only' value="Diarrhea" />Diarrhea</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_6" name="cbEliminationProcess_6" className='add-only' value="Hemorrhoids" />Hemorrhoids </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbEliminationProcess_7" name="cbEliminationProcess_7" className='add-only' value="Pain" />Pain </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other: </span>
                            <input type="text" id="txtOther_1" name="txtOther_1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Stool frequency: </span>
                            <input type="text" id="txtStoolFrequency" name="txtStoolFrequency" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Last BM: </span>
                            <input type="text" id="txtLastBM" name="txtLastBM" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appetite:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="radio" id="rbAppetite_1" name="rbAppetite" className='add-only' value="No change" /> No change</td>
                        <td className='w-187'><input type="radio" id="rbAppetite_2" name="rbAppetite" className='add-only' value="Decreased" /> Decreased</td>
                        <td className='w-187'><input type="radio" id="rbAppetite_3" name="rbAppetite" className='add-only' value="Increased" /> Increased</td>
                        <td className='w-187'><input type="radio" id="rbAppetite_4" name="rbAppetite" className='add-only' value="Binging/Purging" /> Binging/Purging</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Weight Change: </span>
                            <input type="text" id="txtWeightChange" name="txtWeightChange" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Special Diet: </span>
                            <input type="text" id="txtSpecialDiet" name="txtSpecialDiet" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>GENITOURINARY: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Urinary process:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_1" name="cbUrinaryProcess_1" className='add-only' value="Normal" />Normal</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_2" name="cbUrinaryProcess_2" className='add-only' value="Urgent" />Urgent</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_3" name="cbUrinaryProcess_3" className='add-only' value="Frequency" />Frequency</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_4" name="cbUrinaryProcess_4" className='add-only' value="Incontinence" />Incontinence</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_5" name="cbUrinaryProcess_5" className='add-only' value="UTIs" />UTIs</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_6" name="cbUrinaryProcess_6" className='add-only' value="Nocturia" />Nocturia</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_7" name="cbUrinaryProcess_7" className='add-only' value="Hematuria" />Hematuria</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbUrinaryProcess_8" name="cbUrinaryProcess_8" className='add-only' value="Retention" />Retention</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtUrinaryProcess_Comments" name="txtUrinaryProcess_Comments" className='add-only'></textarea>
                </p>
                <h3>SEXUALITY/REPRODUCTION: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Female</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFemale_1" name="cbFemale_1" className='add-only' value="N/A" />N/A</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFemale_2" name="cbFemale_2" className='add-only' value="Post Menopausal" />Post Menopausal </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFemale_3" name="cbFemale_3" className='add-only' value="LMP" />LMP</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFemale_4" name="cbFemale_4" className='add-only' value="Hormone replacement" />Hormone replacement </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFemale_5" name="cbFemale_5" className='add-only' value="Breast SBE monthly/mammogram" />Breast SBE monthly/mammogram </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Pregnant, due date:</span>
                            <input id="txtPregnantDueDate" name="txtPregnantDueDate" className='add-only' type='date' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Last Pap: </span>
                            <input type="text" id="txtLastPap" name="txtLastPap" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Male</span>
                            <input type="checkbox" id="cbMale_1" name="cbMale_1" className='add-only' value="N/A" />N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Last prostrate exam: </span>
                            <input type="text" id="txtLastProstrateExam" name="txtLastProstrateExam" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Any sexual concerns</span>
                            <input type="radio" id="rbSexualConcerns_No" name="rbSexualConcerns" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbSexualConcerns_Yes" name="rbSexualConcerns" className='add-only' value="Yes" /> Yes(Describe):
                            <input type="text" id="txtSexualConcerns" name="txtSexualConcerns" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Practicing safe sex</span>
                            <input type="radio" id="rbPracticing_No" name="rbPracticing" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbPracticing_Yes" name="rbPracticing" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Completed referral criteria for Prevention Counseling and HIV Testing:</span>
                            <input type="radio" id="rbHivTesting_No" name="rbHivTesting" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbHivTesting_Yes" name="rbHivTesting" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbHivTesting_Declined" name="rbHivTesting" className='add-only' value="Declined" /> Declined
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtHivTesting_Comments" name="txtHivTesting_Comments" className='add-only'></textarea>
                </p>
                <h3>PAIN SCREENING: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you have physical pain?</span>
                            <input type="radio" id="rbPhysicalPain_No" name="rbPhysicalPain" className='add-only' value="No" />  No &nbsp;
                            <input type="radio" id="rbPhysicalPain_Yes" name="rbPhysicalPain" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <strong>If yes,</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> describe: </span>
                            <input type="text" id="txtPhysicalPain_Describe" name="txtPhysicalPain_Describe" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_1" name="cbPhysicalPain_1" className='add-only' value="Sharp/stabbing" />Sharp/stabbing </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_2" name="cbPhysicalPain_2" className='add-only' value="Burning" />Burning</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_3" name="cbPhysicalPain_3" className='add-only' value="Crushing/squeezing" />Crushing/squeezing </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_4" name="cbPhysicalPain_4" className='add-only' value="Tingling" />Tingling</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_5" name="cbPhysicalPain_5" className='add-only' value="Stinging" />Stinging</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalPain_6" name="cbPhysicalPain_6" className='add-only' value="Ache" />Ache</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPhysicalPain_Other" name="cbPhysicalPain_Other" className='add-only' value="Other" /> Other:
                            <input type="text" id="txtPhysicalPain_Other" name="txtPhysicalPain_Other" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table >
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>On a scale of zero to ten, with zero meaning no pain and ten meaning the worst pain ever,
                                which number best describes your pain? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_1" name="rbScale" className='add-only' value="0" /> 0</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_2" name="rbScale" className='add-only' value="1" /> 1</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_3" name="rbScale" className='add-only' value="2" /> 2</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_4" name="rbScale" className='add-only' value="3" /> 3</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_5" name="rbScale" className='add-only' value="4" /> 4</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_6" name="rbScale" className='add-only' value="5" /> 5</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_7" name="rbScale" className='add-only' value="6" /> 6</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_8" name="rbScale" className='add-only' value="7" /> 7</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_9" name="rbScale" className='add-only' value="8" /> 8</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_10" name="rbScale" className='add-only' value="9" /> 9</td>
                        <td className='w-60'>
                            <input type="radio" id="rbScale_11" name="rbScale" className='add-only' value="10" /> 10</td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <span><strong>NO <br /> PAIN</strong></span>

                        </td>
                        <td className='w-530'>

                        </td>
                        <td className='w-60'>
                            <span ><strong>WORST &nbsp;&nbsp;PAIN</strong></span>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Where is your pain?</span>
                            <input type="text" id="txtPain" name="txtPain" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>How long does your pain last?</span>
                            <input type="text" id="txtPainLast" name="txtPainLast" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How often do you have this pain? </span>
                            <input type="text" id="txtThisPain" name="txtThisPain" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>What make this pain better? </span>
                            <input type="text" id="txtPainBetter" name="txtPainBetter" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What pain management techniques have you tried?</span>
                            <input type="text" id="txtManagementTechniques" name="txtManagementTechniques" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Who is currently treating your plan?</span>
                            <input type="text" id="txtCurrentlyTreating" name="txtCurrentlyTreating" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Referred to:</span>
                            <input type="text" id="txtReferred" name="txtReferred" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date: </span>
                            <input id="txtDate_1" name="txtDate_1" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Time:</span>
                            <input type="time" id="txtTime" name="txtTime" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Release Signed:</span>
                            <input type="radio" id="rbReleaseSigned_No" name="rbReleaseSigned" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbReleaseSigned_Yes" name="rbReleaseSigned" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Special instructions to the consumer: </span>
                    <textarea id="txtSpecialInstructions" name="txtSpecialInstructions" className='add-only'></textarea>
                </p>

                <h3>ADULT NUTRITIONAL RISK SCREENING: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. BMI = </span>
                            <input type="text" id="txtBMI" name="txtBMI" className='add-only' />
                            (For Children: Attach Growth Chart)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. One of the following physical health problems:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Unexplained weight changes:</span>
                            <input type="text" id="txtWeight" name="txtWeight" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>#Ibs in </span>
                            <input type="text" id="txtIbs" name="txtIbs" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>#weeks</span>
                            <input type="text" id="txtWeeks" name="txtWeeks" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDiabetes" name="cbDiabetes" className='add-only' value="Diabetes" />
                            Diabetes</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHypertension" name="cbHypertension" className='add-only' value="Hypertension" />
                            Hypertension</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCoronaryArteryDisease" name="cbCoronaryArteryDisease" className='add-only' value="Coronary Artery Disease" />
                            Coronary Artery Disease </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDigestiveDisorders" name="cbDigestiveDisorders" className='add-only' value="Digestive Disorders" />
                            Digestive Disorders </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGastricBypassSurgery" name="cbGastricBypassSurgery" className='add-only' value="Gastric Bypass Surgery" />
                            Gastric Bypass Surgery </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPregnant" name="cbPregnant" className='add-only' value="Pregnant" />
                            Pregnant</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBreastFeeding" name="cbBreastFeeding" className='add-only' value="Breast Feeding" />
                            Breast Feeding </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbChemoRadiation" name="cbChemoRadiation" className='add-only' value="Chemo/Radiation" />
                            Chemo/Radiation</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAidsHiv" name="cbAidsHiv" className='add-only' value="AIDS/HIV" />
                            AIDS/HIV </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="Other" />
                            Other:
                            <input type="text" id="txtOther_2" name="txtOther_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. Eating Disorder: Specify </span>
                            <input type="text" id="txtEatingDisorder" name="txtEatingDisorder" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>Describe a typical day of meals and snacks including portion size:</h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Breakfast:</span>
                            <input type="text" id="txtBreakfast" name="txtBreakfast" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Lunch:</span>
                            <input type="text" id="txtLunch" name="txtLunch" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dinner:</span>
                            <input type="text" id="txtDinner" name="txtDinner" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Snacks (name type of snack and frequency): </span>
                            <input type="text" id="txtSnacks" name="txtSnacks" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Who is currently treating your nutritional problems? </span>
                            <input type="text" id="txtNutritionalProblems" name="txtNutritionalProblems" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Referred to: </span>
                            <input type="text" id="txtReferredTo" name="txtReferredTo" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span>
                            <input type="text" id="txtAddress" name="txtAddress" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone #:</span>
                            <input type="text" id="txtTelephone" name="txtTelephone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Release Signed:</span>
                            <input type="radio" id="rbRelease_Yes" name="rbRelease" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbRelease_No" name="rbRelease" className='add-only' value="No" /> No,
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span><strong>If No,</strong></span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>explain: </span>
                    <textarea id="txtRelease_Explain" name="txtRelease_Explain" className='add-only'></textarea>
                </p>
                <h3>NURSING CARE CONCERNS FOR CONSUMER: </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicationEducation" name="cbMedicationEducation" className='add-only' value="Medication Education/Monitoring/Labs" />
                            Medication Education/Monitoring/Labs</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSelfAdministration" name="cbSelfAdministration" className='add-only' value="Training for self-administration of medication" />
                            Training for self-administration of medication</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbNutritionalEducation" name="cbNutritionalEducation" className='add-only' value="Nutritional Education/Monitoring" />
                            Nutritional Education/Monitoring </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUrineDrug" name="cbUrineDrug" className='add-only' value="Random Urine Drug Screens" />
                            Random Urine Drug Screens </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClozarilClinic" name="cbClozarilClinic" className='add-only' value="Clozaril Clinic" />
                            Clozaril Clinic </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicationAdministration" name="cbMedicationAdministration" className='add-only' value="Medication Administration" />
                            Medication Administration  </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEducationRegarding" name="cbEducationRegarding" className='add-only' value="Education Regarding Medication" />
                            Education Regarding Medication </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicalIssues" name="cbMedicalIssues" className='add-only' value="Follow up with health/medical issues" />
                            Follow-up with health/medical issues </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther_3" name="cbOther_3" className='add-only' value="Other" />
                            Other:
                            <input type="text" id="txtOther_3" name="txtOther_3" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>TUBERCULIN SKIN TEST: </h3>
                <p className='w-750'>
                    <span className='small'>(Addictive Disease consumers only) </span>
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbTuberculinTest_NA" name="cbTuberculinTest_NA" className='add-only' value="NA" /> NA
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>0.1 mt PPD (5TU) Tuberculin skin test given, site:</span>
                    <input type="text" id="txtTuberculinSkin" name="txtTuberculinSkin" className='add-only' />
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>History of previous positive test(s)/treatment(s):</span>
                    <textarea id="txtPositiveTest" name="txtPositiveTest" className='add-only'></textarea>
                </p>
                <h3>TUBERCULIN SKIN TEST RESULT: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTuberculinTestResult_NA" name="cbTuberculinTestResult_NA" className='add-only' value="NA" /> NA</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Read: </span>
                            <input id="txtDateRead" name="txtDateRead" className='add-only' type='date' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Results:</span>
                            <input type="text" id="txtResults" name="txtResults" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Co-signature(if necessary) </span>
                            <input type="text" id="txtCoSignature" name="txtCoSignature" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>ADDICTIVE DISEASE OUTPATIENT CHECKLIST </h3>
                <span className='small'>(Addictive Disease consumers only) </span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>RPC (test #: 132) </span>
                            <input type="text" id="txtRPC" name="txtRPC" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>UDS (test # 4106) </span>
                            <input type="text" id="txtUDS" name="txtUDS" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CBC (test #: 114) </span>
                            <input type="text" id="txtCBC" name="txtCBC" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>CMP (test # ) </span>
                            <input type="text" id="txtCMP" name="txtCMP" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Urinalysis (test #: 134) </span>
                            <input type="text" id="txtUrinalysis" name="txtUrinalysis" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>TB Skin Test (within one year) </span>
                            <input type="text" id="txtSkinTest" name="txtSkinTest" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td >
                            <center>
                                <span>(Test # - located on Doctors Laboratory. Inc. forms) </span></center>
                        </td>
                    </tr>
                </table>
                <h3>SUBSTANCE ABUSE: </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Tobacco</span>
                            <input type="radio" id="rbTobacco_No" name="rbTobacco" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbTobacco_Yes" name="rbTobacco" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Cigarettes#/Day </span>
                            <input type="text" id="txtCigarettes" name="txtCigarettes" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Packs/Day </span>
                            <input type="text" id="txtPacks" name="txtPacks" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Caffeine</span>
                            <input type="radio" id="rbCaffeine_No" name="rbCaffeine" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbCaffeine_Yes" name="rbCaffeine" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Coffee/Cups/Day </span>
                            <input type="text" id="txtCoffee" name="txtCoffee" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Sodas/Day</span>
                            <input type="text" id="txtSodas" name="txtSodas" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance</span>
                            <input type="text" id="txtSubstance" name="txtSubstance" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Age first used </span>
                            <input type="text" id="txtAgeFirstUsed" name="txtAgeFirstUsed" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Amount</span>
                            <input type="text" id="txtAmount" name="txtAmount" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Duration</span>
                            <input type="text" id="txtDuration" name="txtDuration" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date last used </span>
                            <input id="txtDateLastUsed" name="txtDateLastUsed" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>I.V. Drugs: </span>
                            <input type="radio" id="rbDrugs_No" name="rbDrugs" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbDrugs_Yes" name="rbDrugs" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Blackouts:</span>
                            <input type="radio" id="rbBlackouts_No" name="rbBlackouts" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbBlackouts_Yes" name="rbBlackouts" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Attempts to stop or control use?</span>
                            <input type="radio" id="rbControlUse_No" name="rbControlUse" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbControlUse_Yes" name="rbControlUse" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Longest period sober (date): </span>
                            <input id="txtLongestPeriod" name="txtLongestPeriod" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Length of drug use? </span>
                            <input type="text" id="txtLengthOfDrug" name="txtLengthOfDrug" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Consequences of substance uses:</span>
                            <input type="text" id="txtConsequences" name="txtConsequences" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>WITHDRAWAL SYMPTONS: Substance(s):</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCurrent_None" name="cbCurrent_None" className='add-only' value="None" />
                            None</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCurrent_Headaches" name="cbCurrent_Headaches" className='add-only' value="Headaches" />
                            Headaches</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCurrent_NV" name="cbCurrent_NV" className='add-only' value="N&V" />
                            N&V</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCurrent_Tremors" name="cbCurrent_Tremors" className='add-only' value="Tremors & Shakes" />
                            Tremors & Shakes </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCurrent_Diaphoresis" name="cbCurrent_Diaphoresis" className='add-only' value="Diaphoresis" />
                            Diaphoresis</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Past:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_None" name="cbPast_None" className='add-only' value="None" />
                            None</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_Headaches" name="cbPast_Headaches" className='add-only' value="Headaches" />
                            Headaches</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_NV" name="cbPast_NV" className='add-only' value="N&V" />
                            N&V</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_Tremors" name="cbPast_Tremors" className='add-only' value="Tremors & Shakes" />
                            Tremors & Shakes </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_Diaphoresis" name="cbPast_Diaphoresis" className='add-only' value="Diaphoresis" />
                            Diaphoresis</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_Withdrawal" name="cbPast_Withdrawal" className='add-only' value="Withdrawal Seizures" />
                            Withdrawal Seizures </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPast_DTs" name="cbPast_DTs" className='add-only' value="DTs" />
                            DTs</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Nurse Signature & Title: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <h3><center>Brief Mental Status Exam (MSE) Form</center></h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="asual dress normal grooming and hygiene" />
                            casual dress, normal grooming and hygiene </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAppearance_Other" name="txtAppearance_Other" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. Attitude</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAttitude_1" name="cbAttitude_1" className='add-only' value="cairn and cooperative" />
                            calm and cooperative </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAttitude_2" name="cbAttitude_2" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAttitude_Other" name="txtAttitude_Other" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. Behavior </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="no unusual movements or psychomotor changes" />
                            no unusual movements or psychomotor changes</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtBehavior_Other" name="txtBehavior_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. Speech </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="normal rate/tone/volume w/out pressure" />
                            normal rate/tone/volume w/out pressure</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSpeech_Other" name="txtSpeech_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5. Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="reactive and mood congruent" />
                            reactive and mood congruent </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="normal range" />
                            normal range </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="labile" />
                            labile </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="depressed" />
                            depressed</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="tearful" />
                            tearful</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="constricted" />
                            constricted </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_7" name="cbAffect_7" className='add-only' value="blunted" />
                            blunted</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_8" name="cbAffect_8" className='add-only' value="flat" />
                            flat</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAffect_9" name="cbAffect_9" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAffect_Other" name="txtAffect_Other" className='add-only'></textarea>
                </p>

                <span className='eleHeader'>6. Mood </span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="reactive and mood congruent" />
                            reactive and mood congruent </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="normal range" />
                            normal range </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="labile" />
                            labile  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="depressed" />
                            depressed </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="tearful" />
                            tearful</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtMood_Other" name="txtMood_Other" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. Thought Processes</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcesses_1" name="cbThoughtProcesses_1" className='add-only' value="goal directed and logical" />
                            goal-directed and logical</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcesses_2" name="cbThoughtProcesses_2" className='add-only' value="disorganized" />
                            disorganized</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbThoughtProcesses_3" name="cbThoughtProcesses_3" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtThoughtProcesses_Other" name="txtThoughtProcesses_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. Thought Content</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h4>suicidal ideation:</h4>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbSuicidal_1" name="rbSuicidal_1" className='add-only' value="None" /> None </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSuicidal_2" name="rbSuicidal_2" className='add-only' value="passive" /> passive </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSuicidal_3" name="rbSuicidal_3" className='add-only' value="active" /> active  </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>If active:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>plan</span>
                            <input type="radio" id="rbPlanYes_1" name="rbPlan_1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbPlanNo_1" name="rbPlan_1" className='add-only' value="No" />  No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>intent</span>
                            <input type="radio" id="rbIntentYes_2" name="rbIntent_1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbIntentNo_2" name="rbIntent_1" className='add-only' value="No" />  No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>means</span>
                            <input type="radio" id="rbMeansYes_3" name="rbMeans_1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbMeansNo_3" name="rbMeans_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h4>Homicidal ideation:</h4>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbHomicidal_1" name="rbHomicidal_1" className='add-only' value="None" /> None </td>
                        <td className='w-250'>
                            <input type="radio" id="rbHomicidal_2" name="rbHomicidal_2" className='add-only' value="passive" /> passive </td>
                        <td className='w-250'>
                            <input type="radio" id="rbHomicidal_3" name="rbHomicidal_3" className='add-only' value="active" />  active </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>If active: </strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>plan</span>
                            <input type="radio" id="rbPlanYes_4" name="rbPlan_2" className='add-only' value="Yes" />  Yes &nbsp;
                            <input type="radio" id="rbPlanNo_4" name="rbPlan_2" className='add-only' value="No" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>intent</span>
                            <input type="radio" id="rbIntentYes_5" name="rbIntent_2" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbIntentNo_5" name="rbIntent_2" className='add-only' value="No" /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>means</span>
                            <input type="radio" id="rbMeansYes_6" name="rbMeans_2" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbMeansNo_6" name="rbMeans_2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidal_1" name="cbSuicidal_1" className='add-only' value="delusions" />
                            delusions </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidal_2" name="cbSuicidal_2" className='add-only' value="obsessions compulsions" />
                            obsessions/ compulsions </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSuicidal_3" name="cbSuicidal_3" className='add-only' value="phobias" />
                            phobias </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSuicidal_4" name="cbSuicidal_4" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSuicidal_Other" name="txtSuicidal_Other" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. Perception</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPerception_1" name="cbPerception_1" className='add-only' value="no hallucinations or delusions during interview" />
                            no hallucinations or delusions during interview </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPerception_2" name="cbPerception_2" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPerception_Other" name="txtPerception_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. Orientation </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h4>Oriented:</h4>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="time" />
                            time </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="place" />
                            place</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="person" />
                            person </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="self" />
                            self</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOrientation_5" name="cbOrientation_5" className='add-only' value="other" />
                            other (describe):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOrientation_Other" name="txtOrientation_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>11. Memory/ Concentration </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMemoryConcentration_1" name="cbMemoryConcentration_1" className='add-only' value="short term intact" />
                            short term intact </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMemoryConcentration_2" name="cbMemoryConcentration_2" className='add-only' value="long term intact" />
                            long term intact </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMemoryConcentration_3" name="cbMemoryConcentration_3" className='add-only' value="distractable/ inattentive" />
                            distractable/ inattentive </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemoryConcentration_4" name="cbMemoryConcentration_4" className='add-only' value="other" />
                            other (describe): </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtMemoryConcentration_Other" name="txtMemoryConcentration_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>12. Insight/Judgement </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightJudgement_1" name="rbInsightJudgement_1" className='add-only' value="good" /> good </td>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightJudgement_2" name="rbInsightJudgement_2" className='add-only' value="fair" /> fair </td>
                        <td className='w-250'>
                            <input type="radio" id="rbInsightJudgement_3" name="rbInsightJudgement_3" className='add-only' value="poor" /> poor </td>
                    </tr>
                </table>
                <h4>
                    <center>
                        ABNORMAL INVOLUNTARY MOVEMENT SCALE(AIMS)
                        <br />
                        Alcohol, Drug Abuse, and Mental Health Administration
                    </center>
                </h4>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>INSTRUCTIONS: </strong>Complete Examination procedure (attachment d.) Before making ratings </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>MOVEMENT RATINGS:</strong>Rate highest severity observed. Rate
                                movements that occur upon activation one less than those observed spontaneously. </span>
                        </td>
                        <td className='w-300'>
                            <span><strong>CODE &nbsp;</strong></span>
                            <span ><strong> &nbsp;0=None,   &nbsp;1=Minimal, may be extreme normal </strong></span>
                            <span ><strong>2=Mild, 3=Moderate,  4 Severe </strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span>Circle movement as well as code number that applies. </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Facial and Oral Movements </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>1. Muscles of Facial Expression (e.g movements of forehead, eyebrows. penorbital area.
                                cheeks, including frowning. blinking, smiling, grimacing)</strong></span>
                            <span>(e.g movements of forehead, eyebrows. penorbital area.
                                cheeks, including frowning. blinking, smiling, grimacing )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_1_1" name="rbRater_1" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_2" name="rbRater_1" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_3" name="rbRater_1" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_4" name="rbRater_1" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_5" name="rbRater_1" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>2. Lips and Perioral Area </strong></span>
                            <br />
                            <span>(e.g.. puckering, pouting, smacking )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_2_1" name="rbRater_2" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_2" name="rbRater_2" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_3" name="rbRater_2" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_4" name="rbRater_2" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_5" name="rbRater_2" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>3. Jaw </strong></span><br />
                            <span>(e.g. biting, clenching. chewing. mouth opening, lateral movement )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_3_1" name="rbRater_3" className='add-only' value="0" />  0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_2" name="rbRater_3" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_3" name="rbRater_3" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_4" name="rbRater_3" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_5" name="rbRater_3" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>4. Tongue Rate </strong></span>
                            <span>(only increases in movement both in and out
                                of mouth. NOT inability to sustain movement. Darting in
                                and Out -Of rrrOutfr.)</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="rbRater_4_1" name="rbRater_4" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_2" name="rbRater_4" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_3" name="rbRater_4" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_4" name="rbRater_4" className='add-only' value="3" />  3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_5" name="rbRater_4" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Extremity Movements</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>5. Upper (arms, wrists„ hands, fingers) </strong></span>
                            <span>Include choreic movements (i.e., rapid, objectively purposeless.
                                Irregular, spontaneous) athetoid movements (i.e. slow, irregular,
                                complex, serpentine). DO NOT INCLUDE TREMOR
                                (i.e.. repetitive. regular, rhythmic) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_5_1" name="rbRater_5" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_2" name="rbRater_5" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_3" name="rbRater_5" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_4" name="rbRater_5" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_5" name="rbRater_5" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>6. Lower (legs, knees, ankles, toes) </strong></span>
                            <span>(e.g.. lateral knee movement. foot tapping, heel dropping. foot
                                squirming. inversion and eversion of foot.) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_6_1" name="rbRater_6" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_2" name="rbRater_6" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_3" name="rbRater_6" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_4" name="rbRater_6" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_5" name="rbRater_6" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Trunk Movements</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>7. Neck, shoulders, hips </strong></span>
                            <span>(e.g . rocking, twisting, squirming, pelvic gyrations )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_7_1" name="rbRater_7" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_2" name="rbRater_7" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_3" name="rbRater_7" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_4" name="rbRater_7" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_5" name="rbRater_7" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Global Judgments</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>8. Severity of abnormal movements overall </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_8_1" name="rbRater_8" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_2" name="rbRater_8" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_3" name="rbRater_8" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_4" name="rbRater_8" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_5" name="rbRater_8" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>9. Incapacitation due to abnormal movements </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_9_1" name="rbRater_9" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_2" name="rbRater_9" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_3" name="rbRater_9" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_4" name="rbRater_9" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_5" name="rbRater_9" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>10. Patient's awareness of abnormal movements</strong></span>
                            <span>(Rate only patient's report No awareness 0 Aware, no distress 1 Aware, mild distress 2 Aware, moderate distress 3 Aware, severe distress 4) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_10_1" name="rbRater_10" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_2" name="rbRater_10" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_3" name="rbRater_10" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_4" name="rbRater_10" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_5" name="rbRater_10" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>11. Do movements disappear in sleep? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_11_1" name="rbRater_11" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_11_2" name="rbRater_11" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'> Dental Status</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>12. Current problems with teeth and/or dentures? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_12_1" name="rbRater_12" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_12_2" name="rbRater_12" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>13. Are dentures usually worn? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="rbRater_13_1" name="rbRater_13" className='add-only' value="No" /> No&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_13_2" name="rbRater_13" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>14. Edentia? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_14_1" name="rbRater_14" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_14_2" name="rbRater_14" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}